import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import { useSearchEventsMutation } from "../../../../Redux/apis/ApiSlice";
import { notification, QRCode } from "antd";
import eventCardDefaultIMG from "../../../../Images/EventCardDefaultIMG.jpg";
const FeaturedEvents = () => {
  const [page, setPage] = useState(1);
  const itemsPerPage = 3;
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const [searchEvents] = useSearchEventsMutation();
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await searchEvents({
          eventName: "",
          location: "",
          dateRange: [],
          status: "",
          featured: true,
          page,
          limit: itemsPerPage,
        }).unwrap();
        if (response.message === "success!") {
          setEvents(response.events);
        } else {
          setError("Failed to fetch events.");
        }
      } catch (err) {
        setError("An error occurred while fetching events.");
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, [searchEvents]);
  if (loading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <Typography>Loading...</Typography>
      </Box>
    );
  if (error)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <Typography color="error">
          Unable to retrieve events. Please try again later.
        </Typography>
      </Box>
    );
  const eventCount = events?.length;
  const slidesToShow = eventCount === 1 ? 1 : eventCount === 2 ? 2 : 3;
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: eventCount === 1 ? 1 : 2,
          centerMode: true,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  };
  return (
    <Container maxWidth="lg">
      <Typography
        align="center"
        variant="h4"
        sx={{
          fontSize: { xs: 24, sm: 32, md: 40 },
          fontWeight: 600,
          textAlign: "center",
          mb: 2,
        }}
      >
        Featured <span className="txt-shine">Events</span>
      </Typography>
      <Typography
        align="center"
        sx={{
          fontSize: { xs: "1rem", md: "1.5rem" },
          fontWeight: 600,
          color: "#535353",
          textAlign: "center",
          mb: { xs: 0, md: 4 },
        }}
      >
        Explore what's ahead
      </Typography>
      <Grid
        container
        spacing={3}
        alignItems="center"
        justifyContent="center"
        // sx={{ mt: 4 }}
      >
        <Grid item>
          <Box
            onClick={() => sliderRef.current.slickPrev()}
            sx={{ cursor: "pointer", display: { xs: "none", md: "block" } }}
          >
            <ArrowBackIosIcon sx={{ fontSize: 30, color: "black" }} />
          </Box>
        </Grid>
        <Grid item xs={12} md={9} sx={{ position: "relative" }}>
          <ArrowBackIosIcon
            onClick={() => sliderRef.current.slickPrev()}
            sx={{
              fontSize: 28,
              color: "black",
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 3,
              cursor: "pointer",
              display: { xs: "none", md: "none" },
              borderRadius: "50%",
              padding: "8px",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 1)",
              },
            }}
          />
          <Slider
            ref={sliderRef}
            {...settings}
            sx={{
              overflow: "hidden",
            }}
          >
            {events?.length === 0 ? (
              <Box px={1.5}>
                <Card
                  sx={{
                    borderRadius: "4px",
                    height: "100%",
                    mx: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#F5F5F5",
                  }}
                >
                  <CardContent sx={{ textAlign: "center" }}>
                    <Typography variant="h6" sx={{ color: "#888" }}>
                      No events available
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            ) : (
              events.slice(0, 15).map((event, index) => {
                let hasImage = event.eventPhoto && event.eventPhoto.length > 0;

                return (
                  <Box
                    key={event.eventId}
                    px={{ xs: 0.5, md: 1.5 }}
                    id={`event-card ${index}`}
                    sx={{
                      display: "flex !important",
                      justifyContent: "center !important",
                    }}
                  >
                    <Card
                      onClick={() =>
                        navigate(`/detail/${event.eventId}`, {
                          state: { event },
                        })
                      }
                      sx={{
                        borderRadius: "8px",
                        height: "420px",
                        width: "296px",
                        mx: { xs: 1, md: 1.5 },
                        position: "relative",
                        backgroundColor: "#000000",
                        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${
                          hasImage ? event.eventPhoto[0] : eventCardDefaultIMG
                        })`,
                        "&:hover": {
                          transform: "translateY(-5px)",
                          transition: "all 0.3s ease",
                        },
                        backgroundSize: "cover",
                        backgroundPosition: "center top",
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        overflow: "hidden",
                        margin: { xs: "0 auto", md: "initial" },
                        maxWidth: "100%",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <Box sx={{ p: 3, zIndex: 2 }}>
                        <Typography sx={{ color: "white", fontSize: "14px" }}>
                          {event.status}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          position: "absolute",
                          zIndex: 1,
                          backgroundColor: "#fff",
                          padding: "5px",
                          borderRadius: "5px",
                          top: 10,
                          right: 10,
                          /*      ...(!hasImage
                            ? {
                                top: "22.5%",
                                left: "50%",
                                transform: "translate(-50%, -22.5%)",
                              }
                            : {
                                top: 10,
                                right: 10,
                              }), */
                        }}
                      >
                        <QRCode
                          value={`https://gxtickets.com/detail/${event.eventId}`}
                          size={80}
                          bordered={false}
                          color="#000"
                          errorLevel="H"
                        />
                      </Box>

                      <Box sx={{ p: 3, zIndex: 2 }}>
                        <Typography
                          sx={{ color: "white", fontSize: "14px", mb: 1 }}
                        >
                          {new Date(event.date).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          })}
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "white",
                            fontWeight: 600,
                            fontSize: "24px",
                            mb: 0.5,
                          }}
                        >
                          {event.eventName}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2,
                          }}
                        >
                          <Typography
                            sx={{
                              color: "white",
                              fontSize: "14px",
                            }}
                          >
                            {event.location}
                          </Typography>
                          <Typography
                            sx={{
                              color: "white",
                              fontSize: "20px",
                              fontWeight: 600,
                            }}
                          >
                            ${event.ticket?.[0]?.subTickets?.[0]?.price || 0}
                          </Typography>
                        </Box>
                        <Box
                          className="btn-shine"
                          sx={{
                            border: "1px solid #535353",
                            width: "100%",
                            height: "53px",
                            borderRadius: "4px",
                            bgcolor: "rgba(255, 255, 255, 0.34)",
                            backdropFilter: "blur(10px)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              bgcolor: "rgba(255, 255, 255, 0.4)",
                            },
                          }}
                          onClick={() =>
                            navigate(`/detail/${event.eventId}`, {
                              state: { event },
                            })
                          }
                        >
                          <Typography
                            sx={{
                              color: "white",
                              fontSize: "16px",
                              fontWeight: 600,
                              letterSpacing: "0.5px",
                            }}
                          >
                            GET TICKETS
                          </Typography>
                        </Box>
                      </Box>
                    </Card>
                  </Box>
                );
              })
            )}
          </Slider>
          <ArrowForwardIosIcon
            onClick={() => sliderRef.current.slickNext()}
            sx={{
              fontSize: 28,
              color: "black",
              position: "absolute",
              right: -15,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 3,
              cursor: "pointer",
              display: { xs: "none", md: "none" },
              borderRadius: "50%",
              padding: "8px",
            }}
          />
        </Grid>
        <Grid item>
          <Box
            onClick={() => sliderRef.current.slickNext()}
            sx={{ cursor: "pointer", display: { xs: "none", md: "block" } }}
          >
            <ArrowForwardIosIcon sx={{ fontSize: 30, color: "black" }} />
          </Box>
        </Grid>
      </Grid>
      <Box mt={{ xs: 0, md: 5 }} textAlign="center">
        <Button
          className="count-shine"
          sx={{
            color: "#535353",
            border: "1px solid #535353",
            padding: "12px 16px",
            width: "168px",
            height: "48px",
            fontWeight: 700,
            fontSize: "16px",
            borderRadius: "4px",
            gap: "8px",
          }}
          onClick={() => navigate("./search")}
        >
          See ALL EVENTS
        </Button>
      </Box>
    </Container>
  );
};
export default FeaturedEvents;
